module.exports = __webpack_public_path__ + "img/htcm_10.30e04596.jpg";